<template>
    <div>
        <div class="form-group row mb-3">
            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('managerForm.settingSerialCode.selecPrizeCalendar') }}</label>
            <div class="col-sm-2">
                <Multiselect
                    :id="`selecPrizeCalendar`"
                    :value.sync="formCalenderInit.prize_select"
                    :options="prizeData"
                    :config.sync="CONFIG_SCREEN_CALENDAR.muliselectPrizes"
                    @select="onHandleSelectPrize"
                />
            </div>
        </div>
        <div class="form-group row mb-3">
            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('managerForm.settingSerialCode.tabLotteryCalendar') }}</label>
            <div class="col-sm-9">
                <div
                    v-if="!!formCalenderInit.start_date_winning && !!formCalenderInit.end_date_winning"
                    class="d-flex flex-wrap mb-3"
                    style="gap: 0.5rem"
                >
                    {{ formatDateCommon(formCalenderInit.start_date_winning, 'dateJP') }}
                    <div class="h-100">〜</div>
                    {{ formatDateCommon(formCalenderInit.end_date_winning, 'dateJP') }}
                </div>
            </div>
        </div>
        <div class="form-group row mb-3">
            <label class="col-sm-1 text-nowrap" style="min-width: 120px"
                >{{ $t('managerForm.settingSerialCode.winningTimeSetting') }}
                <span v-if="onHandleCheckFieldRequired(formCalendarConfig.start_time_winning.typesValidate)" class="text-danger">*</span>
            </label>
            <div class="col-sm-9">
                <div class="d-flex" style="gap: 0.5rem">
                    <PickerDate
                        :id="`startTimeWinning`"
                        class="col-sm-1 p-0"
                        style="min-width: 90px"
                        :model.sync="formCalenderInit.start_time_winning"
                        :config.sync="formCalendarConfig.start_time_winning"
                        :disabled="!formCalenderInit.prize_select || isView"
                        @change="onValidField(formCalenderInit.start_time_winning, formCalendarConfig.start_time_winning, 'time')"
                    />
                    <div class="mt-2">〜</div>
                    <div>
                        <PickerDate
                            :id="`endTimeWinning`"
                            class="col-sm-1 p-0"
                            style="min-width: 90px"
                            :model.sync="formCalenderInit.end_time_winning"
                            :config.sync="formCalendarConfig.end_time_winning"
                            :disabled="!formCalenderInit.prize_select || isView"
                            @change="onValidField(formCalenderInit.end_time_winning, formCalendarConfig.end_time_winning, 'time')"
                        />
                        <div v-if="formCalendarConfig.end_time_winning.error" class="invalid-feedback d-block">
                            <span>{{ formCalendarConfig.end_time_winning.errorField }}</span>
                        </div>
                    </div>
                    <div></div>
                </div>
                <div v-if="formCalendarConfig.start_time_winning.error" class="invalid-feedback d-block">
                    <span>{{ formCalendarConfig.start_time_winning.errorField }}</span>
                </div>
            </div>
        </div>
        <div v-if="formCalenderInit.prize_select?.prize_type" style="font-size: 18px">
            <div class="d-flex flex-wrap justify-content-end mb-3">
                <div>
                    <p class="mb-0">
                        {{ $t('managerForm.settingPage.pageTypeB.numberOfWinnerDay') }}
                    </p>
                    <p class="mb-0 text-center">
                        {{ sumDailyLimitPrize }}
                    </p>
                </div>
                <div>／</div>
                <div>
                    <p class="mb-0">
                        {{ $t('managerForm.settingPage.pageTypeB.totalNumberOfWinner') }}
                    </p>
                    <p class="mb-0 text-center">
                        {{ totalNumberWinners }}
                    </p>
                </div>
            </div>
        </div>
        <div style="min-width: 800px; position: relative">
            <FullCalendar ref="CalendarFull" class="custom-full_calendar" :options="calendarOptions">
                <template v-slot:eventContent="arg">
                    <template v-if="arg.event?.extendedProps">
                        <div v-if="arg.event.extendedProps?.year_holiday" class="event-holiday-name text-truncate">
                            {{ arg.event.extendedProps.year_holiday }}
                        </div>
                        <div v-else-if="arg.event.extendedProps?.holiday_name" class="event-holiday-name text-truncate">
                            {{ arg.event.extendedProps.holiday_name }}
                        </div>
                    </template>
                    <template v-if="arg.event?.title">
                        <template v-if="!isDateBeforeToday(arg.event.start)">
                            <div class="box--event event--setting mb-1">
                                <div class="position-relative box--new__event">
                                    <div class="d-flex align-items-center justify-content-center" style="gap: 0.5rem">
                                        <div v-if="!isView" class="event--minus" @click="handleIncrementDecrement(arg, 'minus')">
                                            <i class="fa fa-minus"></i>
                                        </div>
                                        <div class="event--title">
                                            <InputText
                                                :disabled="isView"
                                                :model="tempTitles[arg.event.id] !== undefined ? tempTitles[arg.event.id] : arg.event.title"
                                                :config="CONFIG_SCREEN_CALENDAR.eventTitleInput"
                                                @input="$set(tempTitles, arg.event.id, $event)"
                                                @change="onInputChangeTitle($event, arg)"
                                                @click.stop.native
                                                @mousedown.stop.native
                                                @keydown.stop.native
                                                @keydown.enter.prevent.native="$event.target.blur()"
                                                v-b-tooltip.hover
                                                :title="'当日当選可能数'"
                                            />
                                        </div>
                                        <div v-if="!isView" class="event--plus" @click="handleIncrementDecrement(arg, 'plus')">
                                            <i class="fa fa-plus"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="box--event">
                                <div class="text-center" style="font-weight: 600; color: #74788d">
                                    <span v-b-tooltip.hover :title="'当選数'"> {{ arg.event.extendedProps?.daily_won || 0 }}</span> /
                                    <span v-b-tooltip.hover :title="'残数'">
                                        {{
                                            arg.event.extendedProps?.daily_accumulated_limit?.toString()
                                                ? arg.event.extendedProps?.daily_accumulated_limit
                                                : arg.event.title
                                        }}
                                    </span>
                                </div>
                            </div>
                        </template>
                        <div v-else class="box--event">
                            <span class="d-block text-center" style="font-weight: 600; color: #74788d"
                                >当選数: {{ arg.event.extendedProps?.daily_won }}</span
                            >
                        </div>
                    </template>
                </template>
            </FullCalendar>
        </div>
        <div class="d-flex flex-wrap align-items-center mt-3">
            <div style="font-weight: 600; color: #74788d">{{ $t('managerForm.settingPage.pageTypeB.notePrizeCalendar') }}</div>
            <div class="ml-auto d-flex flex-wrap">
                <div v-for="item in LIST_DAY_OF_WEEK" :key="item">
                    <InputCheckBox
                        class="mr-3"
                        :model.sync="formCalenderInit.checked_day_of_week"
                        :id="`check-LIST_DAY_OF_WEEK${item}`"
                        :value="item"
                        :label="item"
                        :disabled="isView"
                        @change="onHandleDayOfWeek(item)"
                    />
                </div>
            </div>
            <InputText
                style="max-width: 80px"
                :model.sync="otherFieldInit.number_quantity_follow_day"
                :config="{
                    isNumber: true,
                    maxlength: 10,
                    errror: false
                }"
                @change="
                    (evt) => {
                        if (regexNumberZeroMore(evt)) otherFieldInit.number_quantity_follow_day = '0';
                    }
                "
                :disabled="isView"
            />
            <button
                :disabled="isDisabled || !otherFieldInit.number_quantity_follow_day"
                type="button"
                class="btn btn-info"
                @click="onHandleDayOfWeekEvent"
            >
                {{ $t('btn.save') }}
            </button>
        </div>
    </div>
</template>

<script>
import Multiselect from '@/components/Multiselect/main.vue';
import FullCalendar from '@fullcalendar/vue';
import PickerDate from '@/components/DateCustoms/PickerDate/main.vue';
import moment from 'moment';

import { masterMethods } from '@/state/helpers';
import {
    LIST_DAY_OF_WEEK,
    filterDatesByWeekdays,
    CONFIG_SCREEN_CALENDAR,
    initFormCalendar,
    onValidTime,
    createIdEventRangeDate,
    initFieldOther,
    validOrderDateAddEvent,
    toCalendarEnd,
    configFormCalendar,
    splitAllDayEvent,
    onHandleCompareNumberQuatity,
    initInputRanges,
    TITLE_HOLIDAY,
    filterEventsByRange,
    objEventRange,
    onHandleHolidayDefault,
    isDateEqualToToday,
    filterTodayDates,
    onHandleSumDailyLimitPrize,
    splitRecordsByMaxQuantity,
    buildSelectInfoFromEvent,
    onValidQuantitySmallDailyWon,
    isDateBeforeToday,
    getExcludedDateEvents
} from './constants';
import { InputCheckBox, InputText } from '@/components/Input';
import { onHandleCheckFieldRequired } from '@/utils/handlers';
import { showMessage } from '@/utils/messages';
import { formatDateCommon, convertToHalfsize } from '@/utils/format';
import { validateField } from '@/utils/validate_v2';
import { TYPE_PRIZE } from '@/views/pages/phase2/manager-form/components/prize-serial-code/constants';
import { regexNumberZeroMore } from '@/utils/regex';

export default {
    name: 'SettingCalendar',
    components: {
        Multiselect,
        FullCalendar,
        InputCheckBox,
        InputText,
        PickerDate
    },
    props: {
        dataPrizes: {
            type: Array,
            default: () => []
        },
        infoPrizeCalendar: {
            type: Object,
            default: () => {}
        },
        indexPrizeCalendar: {
            type: Number,
            default: 0
        },
        inforLottery: {
            type: Object,
            default: () => {}
        },
        formCalendar: {
            type: Object,
            default: () => {}
        },
        configCalendar: {
            type: Object,
            default: () => {}
        },
        isView: {
            type: Boolean,
            default: () => false
        },
        loading: {
            type: Boolean,
            default: false
        },
        isActive: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            calendarOptions: {
                ...CONFIG_SCREEN_CALENDAR.calendarOptions,
                select: this.handleDateSelect,
                eventsSet: this.handleEvents,
                dayCellClassNames: (arg) => {
                    const events = this.calendarOptions.events || [];
                    if (events.length === 0) return [];
                    const cellDateStr = moment(arg.date).format('YYYY-MM-DD');
                    const dayEvents = events.filter((e) => {
                        const start = moment(e.start).format('YYYY-MM-DD');
                        const end = moment(e.end).format('YYYY-MM-DD');
                        return cellDateStr >= start && cellDateStr < end;
                    });
                    if (dayEvents.length === 0) return [];
                    const hasHoliday = dayEvents.some(
                        (e) => e.classNames?.includes('event-holiday') || e.classNames?.includes('event-year_end_schedule')
                    );
                    const hasAllow = dayEvents.some((e) => e.classNames?.includes('event-allow-range'));
                    if (hasHoliday) return ['holiday--year_schedule'];
                    if (hasAllow) return ['range-dates-event'];
                    return ['range-dates-outside'];
                }
            },
            LIST_DAY_OF_WEEK,
            CONFIG_SCREEN_CALENDAR,
            TYPE_PRIZE,
            formCalenderInit: initFormCalendar(this.formCalendar),
            formCalendarConfig: this.configCalendar || configFormCalendar(),
            otherFieldInit: initFieldOther(),
            prizeData: this.dataPrizes,
            allowRanges: [],
            listHolidayCalendar: [],
            isDayOfWeekEvent: false,
            allowTotalMaximumQuantity: 0,
            quantitySmallDailyWonDate: {},
            isCalendarLoading: false,
            tempTitles: {},
            lastStartDate: null,
            lastEndDate: null
        };
    },
    computed: {
        isDisabled() {
            return (
                !this.formCalenderInit?.prize_select ||
                !this.formCalenderInit.start_date_winning?.length ||
                !this.formCalenderInit.end_date_winning?.length ||
                this?.isView
            );
        },
        isSelectedPrize() {
            return !!this.formCalenderInit?.prize_select;
        },

        sumDailyLimitPrize() {
            return onHandleSumDailyLimitPrize(this.prizeData, this.formCalenderInit.prize_select);
        },

        totalNumberWinners() {
            return this.formCalenderInit.prize_select?.prize_type === TYPE_PRIZE[0].id
                ? this.formCalenderInit.prize_select?.number_in_kind
                : this.formCalenderInit.prize_select?.list_product_import?.length;
        }
    },
    methods: {
        ...masterMethods,
        formatDateCommon,
        onHandleCheckFieldRequired,
        regexNumberZeroMore,
        isDateEqualToToday,
        isDateBeforeToday,

        onHandleOptionEvent(eventData = []) {
            return eventData?.length > 0 ? [...this.allowRanges, ...eventData] : this.allowRanges;
        },

        onInputChangeTitle(value, arg) {
            value = convertToHalfsize(value);
            value = value.replace(/[^\d]/g, '');
            if (value === '') value = '0';
            const quantity = Number(value);
            this.otherFieldInit.number_quantity_modal_date = quantity;
            const inforBuildEvent = buildSelectInfoFromEvent(arg);
            this.CONFIG_SCREEN_CALENDAR.modalCreatEvent.infoSelect = inforBuildEvent;
            this.onHandleCreatEvent();
            this.$delete(this.tempTitles, arg.event.id);
        },

        handleIncrementDecrement(arg, type) {
            if (this.isView) return;
            if (type === 'minus') {
                const quantity = Number(arg.event.title) - 1;
                if (quantity < 0) return;
                if (onValidQuantitySmallDailyWon(quantity, arg.event)) {
                    showMessage(400, this.$bvToast, `当日当選可能数は当日利用済数以上の値を入力してください。`);
                } else {
                    this.otherFieldInit.number_quantity_modal_date = quantity;
                }
            } else {
                const quantity = Number(arg.event.title) + 1;
                this.otherFieldInit.number_quantity_modal_date = quantity;
            }
            const inforBuildEvent = buildSelectInfoFromEvent(arg);
            if (!isDateEqualToToday(inforBuildEvent.startStr)) {
                inforBuildEvent.view.calendar.unselect();
                return;
            }
            this.CONFIG_SCREEN_CALENDAR.modalCreatEvent.infoSelect = inforBuildEvent;
            this.onHandleCreatEvent();
        },

        handleDateSelect(selectInfo) {
            if (this.isView) return;
            if (!isDateEqualToToday(selectInfo.startStr)) {
                selectInfo.view.calendar.unselect();
                return;
            }
            if (!this.onValidOrderDateAddEvent(selectInfo)) return;
            const eventId = createIdEventRangeDate(selectInfo);
            const existingEvent = this.otherFieldInit.apiFullCalendar.getEventById(eventId);
            if (!existingEvent) {
                this.otherFieldInit.apiFullCalendar.addEvent({
                    ...selectInfo,
                    title: '0',
                    id: eventId
                });
            }
            selectInfo.view.calendar.unselect();
        },

        onHandleSelectPrize(prize) {
            if (!prize || this.isInternalUpdate) return;
            this.isInternalUpdate = true;
            if (this.otherFieldInit?.apiFullCalendar) {
                this.otherFieldInit.apiFullCalendar.removeAllEvents();
            }
            const updatedData = this.prizeData.map((p) => {
                const isSelected =
                    (p.make_id && prize.make_id && p.make_id === prize.make_id) || (p.id && prize.id && p.id === prize.id) || p === prize;
                return {
                    ...p,
                    extension: {
                        ...p.extension,
                        is_selected: isSelected
                    }
                };
            });
            this.formCalendarConfig = configFormCalendar();
            this.formCalenderInit = initFormCalendar({
                ...prize,
                start_time_winning: prize?.start_time_winning || this.inforLottery?.start_time_winning,
                end_time_winning: prize?.end_time_winning || this.inforLottery?.end_time_winning
            });
            this.calendarOptions.events = [];
            this.tempTitles = {};
            this.otherFieldInit.number_quantity_follow_day = null;
            this.$emit('selectPrize', prize);
            this.$emit('update:dataPrizes', updatedData);
            this.$nextTick(() => {
                this.isInternalUpdate = false;
            });
        },

        handleEvents(events) {
            if (!this.formCalenderInit.prize_select || events?.length <= 0) return;
            this.onHandleMapCalendarPrize(events);
        },

        onHandleDayOfWeekEvent() {
            if (this.isDayOfWeekEvent) return;
            this.isDayOfWeekEvent = true;
            const dates = filterDatesByWeekdays(
                this.formCalenderInit.start_date_winning,
                this.formCalenderInit.end_date_winning,
                this.formCalenderInit.checked_day_of_week,
                this.listHolidayCalendar
            );

            let formatDateRanges = dates
                .map((item) => ({
                    title: Number(this.otherFieldInit.number_quantity_follow_day),
                    startStr: item,
                    endStr: toCalendarEnd(item)
                }))
                .map((item) => splitAllDayEvent(item))
                .flatMap((item) => item);
            formatDateRanges = filterTodayDates(formatDateRanges);
            let isValid = this.onValidNumberQuantityWinning(
                formatDateRanges,
                this.otherFieldInit.number_quantity_follow_day,
                !(Number(this.otherFieldInit.number_quantity_follow_day) > this.totalNumberWinners)
            );
            if (!isValid) {
                this.otherFieldInit.number_quantity_follow_day = null;
                this.isDayOfWeekEvent = false;
                return;
            }

            // Thực hiện tính toán số lượng phần thưởng trong phạm vi tối đa
            const excludedDateEvents = getExcludedDateEvents(this.formCalenderInit, this.listHolidayCalendar, this.otherFieldInit.apiFullCalendar);
            const { accepted, remaining } = splitRecordsByMaxQuantity(
                [...excludedDateEvents, ...formatDateRanges],
                this.allowTotalMaximumQuantity,
                this.quantitySmallDailyWonDate
            );
            const invalidDates = [];
            accepted.forEach((item) => {
                const eventId = createIdEventRangeDate(item);
                const existingEvent = this.otherFieldInit.apiFullCalendar.getEventById(eventId);
                if (existingEvent) {
                    if (onValidQuantitySmallDailyWon(this.otherFieldInit.number_quantity_follow_day, existingEvent)) {
                        invalidDates.push(existingEvent.startStr);
                        existingEvent.setProp('title', existingEvent.title);
                    } else {
                        existingEvent.setProp(
                            'title',
                            item?.is_not_change_title ? existingEvent.title : this.otherFieldInit.number_quantity_follow_day
                        );
                    }
                } else {
                    this.otherFieldInit.apiFullCalendar.addEvent({
                        ...item,
                        id: eventId,
                        title: this.otherFieldInit.number_quantity_follow_day
                    });
                }
            });

            if (invalidDates.length > 0) {
                showMessage(400, this.$bvToast, `当日当選可能数は当日利用済数以上の値を入力してください。`);
            }

            remaining.forEach((item) => {
                const eventId = createIdEventRangeDate(item);
                const existingEvent = this.otherFieldInit.apiFullCalendar.getEventById(eventId);
                if (existingEvent) {
                    existingEvent.remove();
                }
            });

            this.isDayOfWeekEvent = false;
            this.otherFieldInit.number_quantity_follow_day = null;
        },

        onValidField(valueField, configField, typeField = null) {
            validateField(valueField, configField);
            if (typeField === 'time') {
                onValidTime(this.formCalenderInit, this.formCalendarConfig);
            }
            this.onHandleMapCalendarPrize();
        },

        onHandleMapCalendarPrize(prizeEvts = []) {
            if (!this.formCalenderInit.prize_select) return;
            const indexUpdate = this.prizeData.findIndex(
                (item) =>
                    (item.make_id && this.formCalenderInit.prize_select?.make_id && item.make_id === this.formCalenderInit.prize_select.make_id) ||
                    (item.id && this.formCalenderInit.prize_select?.id && item.id === this.formCalenderInit.prize_select.id) ||
                    item === this.formCalenderInit.prize_select
            );

            if (indexUpdate !== -1) {
                const dateEventPrizes = prizeEvts
                    .filter((efil) => efil?.display !== 'background')
                    ?.map((e) => {
                        return {
                            ...(e?.id !== null && e?.id !== undefined && { id: Number(e?.id) }),
                            title: e.title,
                            startStr: e.startStr,
                            endStr: e.endStr,
                            start: e.start,
                            end: e.end,
                            allDay: e.allDay,
                            extendedProps: {
                                source: e?.extendedProps?.source || 'local',
                                id: e?.extendedProps?.id ?? null,
                                daily_won: e?.extendedProps?.daily_won || 0,
                                daily_accumulated_limit: e?.extendedProps?.daily_accumulated_limit || ''
                            }
                        };
                    });
                this.prizeData.splice(indexUpdate, 1, {
                    ...this.formCalenderInit.prize_select,
                    start_time_winning: this.formCalenderInit.start_time_winning,
                    end_time_winning: this.formCalenderInit.end_time_winning,
                    prize_date_event: {
                        daily_limits: prizeEvts.length > 0 ? dateEventPrizes : this.prizeData[indexUpdate].prize_date_event.daily_limits
                    }
                });
                this.$emit('update:dataPrizes', this.prizeData);
            }
        },

        onHandleCreatEvent() {
            const infoEventDateSelect = this.CONFIG_SCREEN_CALENDAR.modalCreatEvent.infoSelect;
            let calendarApi = infoEventDateSelect.view.calendar;
            calendarApi.unselect();
            if (!this.onValidOrderDateAddEvent(infoEventDateSelect)) {
                this.otherFieldInit.number_quantity_modal_date = null;
                return;
            }
            let isValidQuantityNumber = this.onValidNumberQuantityWinning(
                splitAllDayEvent(infoEventDateSelect),
                this.otherFieldInit.number_quantity_modal_date
            );
            if (!isValidQuantityNumber) {
                this.otherFieldInit.number_quantity_modal_date = null;
                return;
            }
            if (!this.otherFieldInit.number_quantity_modal_date?.toString()) return;
            const dataSplitEvents = splitAllDayEvent(infoEventDateSelect);
            dataSplitEvents.forEach((item) => {
                const eventId = createIdEventRangeDate(item);
                const existingEvent = this.otherFieldInit.apiFullCalendar.getEventById(eventId);
                if (existingEvent) {
                    if (onValidQuantitySmallDailyWon(this.otherFieldInit.number_quantity_modal_date, existingEvent)) {
                        existingEvent.setProp('title', existingEvent.title);
                        showMessage(400, this.$bvToast, `当日当選可能数は当日利用済数以上の値を入力してください。`);
                    } else {
                        existingEvent.setProp('title', this.otherFieldInit.number_quantity_modal_date);
                    }
                } else {
                    this.otherFieldInit.apiFullCalendar.addEvent({
                        ...item,
                        title: this.otherFieldInit.number_quantity_modal_date,
                        id: eventId
                    });
                }
            });
            this.otherFieldInit.number_quantity_modal_date = null;
        },

        onValidOrderDateAddEvent(selectInfo) {
            let isValid = validOrderDateAddEvent(
                this.formCalenderInit.start_date_winning,
                toCalendarEnd(this.formCalenderInit.end_date_winning),
                selectInfo.startStr,
                selectInfo.endStr
            );
            if (!isValid) {
                selectInfo.view?.calendar?.unselect();
                showMessage(422, this.$bvToast, '当選対象期間外となります。');
            }
            return isValid;
        },

        onHandleGoToDate() {
            if (!this.formCalenderInit.start_date_winning) return;
            this.otherFieldInit.apiFullCalendar.gotoDate(this.formCalenderInit.start_date_winning);
        },
        async onHandleCallHoliday() {
            if (
                this.formCalenderInit.checked_day_of_week.length > 0 &&
                (this.formCalenderInit.start_date_winning || this.inforLottery.start_date) &&
                (this.formCalenderInit.end_date_winning || this.inforLottery.end_date) &&
                this.formCalenderInit.checked_day_of_week.includes(TITLE_HOLIDAY)
            ) {
                await this.onHandleGetHolidayDate();
            }
        },
        onHandleDayOfWeek(evt) {
            if (evt === TITLE_HOLIDAY && this.formCalenderInit.checked_day_of_week.includes(TITLE_HOLIDAY)) {
                this.listHolidayCalendar = [];
                this.onHandleGetHolidayDate();
            }
        },
        async onHandleGetHolidayDate() {
            const startDate = this.formCalenderInit.start_date_winning || this.inforLottery.start_date;
            const endDate = this.formCalenderInit.end_date_winning || this.inforLottery.end_date;
            let queryString = `from[date]=${startDate}&to[date]=${endDate}`;
            this.isCalendarLoading = true;
            this.$emit('update:loading', true);
            try {
                const { data } = await this.getListHolidayFilter(queryString);
                this.listHolidayCalendar = data || [];
            } catch (error) {
                showMessage(422, this.$bvToast, error.message);
            } finally {
                this.isCalendarLoading = false;
                this.$emit('update:loading', false);
            }
        },

        onValidNumberQuantityWinning(newDatesRange, numberQuantity, maximumAllowed = false) {
            let check = true;
            const getDailyLimits =
                this.prizeData.find(
                    (item) =>
                        (item?.make_id &&
                            this.formCalenderInit.prize_select?.make_id &&
                            item.make_id === this.formCalenderInit.prize_select.make_id) ||
                        (item?.id && this.formCalenderInit.prize_select?.id && item.id === this.formCalenderInit.prize_select.id) ||
                        item === this.formCalenderInit.prize_select
                )?.prize_date_event?.daily_limits || [];
            const getMaxOnCondition =
                this.formCalenderInit.prize_select?.prize_type === TYPE_PRIZE[1].id
                    ? Number(this.formCalenderInit.prize_select?.list_product_import?.length)
                    : Number(this.formCalenderInit.prize_select?.number_in_kind);
            let allEventBeforeToday = [];
            if (this.otherFieldInit?.apiFullCalendar?.getEvents()) {
                allEventBeforeToday = this.otherFieldInit.apiFullCalendar
                    .getEvents()
                    .filter((item) => item.title && isDateBeforeToday(item.startStr))
                    .map((item) => item);
            }
            let resultCompareNumberQuantity = onHandleCompareNumberQuatity({
                existedRanges: initInputRanges(getDailyLimits),
                newRanges: initInputRanges(newDatesRange, numberQuantity),
                max: getMaxOnCondition,
                isAllowMaximum: maximumAllowed,
                allEventBeforeToday
            });
            if (!resultCompareNumberQuantity.valid) {
                showMessage(422, this.$bvToast, resultCompareNumberQuantity.message);
                check = false;
            }
            this.allowTotalMaximumQuantity = resultCompareNumberQuantity.total;
            this.quantitySmallDailyWonDate = resultCompareNumberQuantity.dateQuantitySmallDailyWon;
            return check;
        },

        onResetData() {
            if (this.otherFieldInit?.apiFullCalendar) {
                this.otherFieldInit.apiFullCalendar.removeAllEvents();
            }
            this.tempTitles = {};
            this.otherFieldInit.number_quantity_follow_day = null;
            this.onHandleSelectPrize(this.prizeData[0]);
        }
    },

    watch: {
        indexPrizeCalendar: {
            handler() {
                if (this.otherFieldInit?.apiFullCalendar) {
                    this.otherFieldInit.apiFullCalendar.removeAllEvents();
                }
                this.tempTitles = {};
                this.otherFieldInit.number_quantity_follow_day = null;
                this.formCalenderInit = initFormCalendar({
                    prize_select: this.infoPrizeCalendar,
                    start_date_winning: this.inforLottery.start_date,
                    end_date_winning: this.inforLottery.end_date,
                    start_time_winning: this.infoPrizeCalendar?.start_time_winning ?? null,
                    end_time_winning: this.infoPrizeCalendar?.end_time_winning ?? null
                });
                const filteredEvents = filterEventsByRange(
                    this.formCalenderInit.prize_select?.prize_date_event?.daily_limits,
                    this.inforLottery.start_date,
                    this.inforLottery.end_date
                );
                this.calendarOptions.events = this.onHandleOptionEvent(filteredEvents);
            },
            deep: true
        },
        isSelectedPrize: {
            handler(valBool) {
                this.calendarOptions.selectable = valBool && !this.isView;
            },
            immediate: true
        },
        dataPrizes: {
            handler(val) {
                this.prizeData = val ?? [];
            },
            immediate: true,
            deep: true
        },
        inforLottery: {
            async handler(valLottery) {
                if (this.isInternalUpdate) return;
                const isDatesChanged = valLottery?.start_date !== this.lastStartDate || valLottery?.end_date !== this.lastEndDate;

                if (valLottery?.start_date) this.formCalenderInit.start_date_winning = valLottery.start_date;
                if (valLottery?.end_date) this.formCalenderInit.end_date_winning = valLottery.end_date;

                if (this.isActive && isDatesChanged) {
                    await this.onHandleCallHoliday();
                    if (this.prizeData.length > 0) {
                        const selectedPrize = this.prizeData.find((p) => p.extension?.is_selected);
                        if (selectedPrize) {
                            this.onHandleSelectPrize(selectedPrize);
                        } else {
                            this.onHandleSelectPrize(this.prizeData[0]);
                        }
                    }
                }
                if (isDatesChanged) {
                    const listHolidayAfterHandle = onHandleHolidayDefault(this.listHolidayCalendar, valLottery);
                    this.allowRanges = [objEventRange(valLottery), ...listHolidayAfterHandle];
                    this.lastStartDate = valLottery?.start_date;
                    this.lastEndDate = valLottery?.end_date;
                }
            },
            immediate: true,
            deep: true
        },
        formCalenderInit: {
            handler(valForm) {
                this.$emit('update:formCalendar', valForm);
            },
            immediate: true,
            deep: true
        },
        isActive: {
            async handler(val) {
                if (val) {
                    await this.onHandleCallHoliday();
                    // Sync prize selection when tab becomes active
                    if (this.prizeData.length > 0) {
                        const selectedPrize = this.prizeData.find((p) => p.extension?.is_selected);
                        if (selectedPrize) {
                            this.onHandleSelectPrize(selectedPrize);
                        } else {
                            this.onHandleSelectPrize(this.prizeData[0]);
                        }
                    }
                }
            }
        }
    },

    mounted() {
        this.otherFieldInit.apiFullCalendar = this.$refs.CalendarFull.getApi();
    }
};
</script>

<style lang="scss">
.custom-full_calendar {
    &.fc {
        .fc-bg-event {
            background: transparent;
            opacity: 1;
        }
    }
    .fc-daygrid-day {
        .fc-scrollgrid-sync-inner {
            background: #e9ecef;
        }
        &.range-dates-event,
        &.holiday--year_schedule {
            .fc-scrollgrid-sync-inner {
                background: #ffffff;
            }
        }
        &.holiday--year_schedule {
            .fc-scrollgrid-sync-inner {
                .fc-daygrid-day-number {
                    color: #ff3232;
                }
                .event-holiday-name {
                    max-width: 90px;
                    position: relative;
                    padding: 4px;
                    z-index: 4;
                }
            }
        }
    }

    .table-bordered th,
    .table-bordered td {
        border: 1px solid #ced4da;
    }
    .table-bordered thead th,
    .table-bordered thead td {
        border-bottom-width: 0px !important;
    }
    .fc-col-header-cell {
        background-color: #255688;
        color: #fff;
        padding: 5px;
    }
    .fc-col-header-cell-cushion {
        font-weight: bold;
    }
    .fc-daygrid-day-number {
        font-weight: 700;
    }

    .box--event {
        font-size: 16px;
    }

    .fc-daygrid-event-harness {
    }
    .fc-h-event {
        border: transparent;
        background: transparent;
    }
    .event--setting {
        width: 100%;
        font-weight: 600;
        color: #74788d;
        display: flex;
        justify-content: center;
        .box--new__event {
            min-width: 100px;
            border: 1px solid #ced4da;
        }
        .event--title {
            cursor: pointer;
            flex: 1;
            text-align: center;
            min-width: 50px;
            .input-event-title {
                width: 50px;
                height: inherit;
                border: 1px solid transparent;
                background: transparent;
                text-align: center;
                font-weight: bold;
                outline: none;
                padding: 0;
                margin: 0;
                color: inherit;
                transition: all 0.2s;
                font-size: inherit;
                &.disabled_cursor {
                    background-color: inherit;
                }
            }
        }
        .delete--event {
            height: 100%;
            &:hover {
                opacity: 0.7;
            }
        }

        .event--minus,
        .event--plus {
            cursor: pointer;
            &:hover {
                opacity: 0.7;
            }
        }

        .event--minus {
            padding-left: 10px;
        }

        .event--plus {
            padding-right: 10px;
        }
    }
}
</style>
